import styled from "@emotion/styled/macro";
import { Pill, tokens, Typography } from "@sunrun/experience-ui-components";
import { OfferReviewInfoTooltip } from "components/atoms/OfferReviewInfoTooltip";
import type { SimplifiedExperienceIneligibleReason } from "utils/simplifiedExperienceDecision";
import {
  getOfferReviewClassicViewTooltipMessage,
  type OfferReviewSimplifiedIneligibleLabelOptions,
} from "utils/simplifiedExperienceReasonLabels";

type ClassicViewPillTooltipProps = {
  reason: SimplifiedExperienceIneligibleReason;
  breezeCreatedDateCutoff?: string | undefined;
  tooltipTestId?: string;
};

const ClassicViewPillTooltip = ({
  reason,
  breezeCreatedDateCutoff,
  tooltipTestId = "offer-review-breeze-ineligible-tooltip",
}: ClassicViewPillTooltipProps) => {
  const tooltipOptions: OfferReviewSimplifiedIneligibleLabelOptions = {
    breezeCreatedDateCutoff,
  };
  const tooltipMessage = getOfferReviewClassicViewTooltipMessage(
    reason,
    tooltipOptions
  );

  return (
    <ClassicViewPill type="info" hideIcon>
      <ClassicViewPillContent>
        <Typography variant="p" color={tokens.BRAND_HEROBLUE}>
          Classic view
        </Typography>
        <OfferReviewInfoTooltip
          content={tooltipMessage}
          ariaLabel="Why you are seeing classic view"
          testId={tooltipTestId}
          iconColor={tokens.BRAND_HEROBLUE}
        />
      </ClassicViewPillContent>
    </ClassicViewPill>
  );
};

const ClassicViewPill = styled(Pill)`
  width: auto !important;
  max-width: none;
  padding: 2px 8px !important;
  border-radius: 999px !important;
  background: ${tokens.INFO_80} !important;
  border: none !important;
`;

const ClassicViewPillContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

export { ClassicViewPillTooltip };
